module.exports = __webpack_public_path__ + "img/prev_months.69b82208.png";